// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"85864635","239":"d9fe31b6","396":"99a53385","455":"ebc77dc5","977":"6f8304ba"}[chunkId] + ".chunk.js";
};